import { render, staticRenderFns } from "./service.vue?vue&type=template&id=78ab9105&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=78ab9105&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ab9105",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopSectionTitle: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/TopSectionTitle.vue').default})
